import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from '../../../../../Button'
import { Types as DeviceAuthTypes, bypassDeviceAuth } from '../../../../../../actions/device/auth'
import { EstateUtils } from '../../../../../../utils'

interface DevyceBypassAuthProps {
    deviceId: string
}

function DeviceBypassAuth({ deviceId }: DevyceBypassAuthProps): JSX.Element | null {
    const dispatch = useDispatch()
    const [display, setDisplay] = React.useState(true)
    const { t } = useTranslation()
    // Use is admin
    const isAdmin: boolean = useSelector((state) => EstateUtils.isAdmin(state))

    if (!isAdmin) {
        return null
    }

    if (!display) {
        return null
    }

    /**
     * On click bypass button
     */
    const onClickBypass = async (): Promise<void> => {
        // If button is disabled, stop
        if (!display) {
            return
        }

        // Disable button
        setDisplay(false)

        // Call API
        const { type } = await dispatch(bypassDeviceAuth(deviceId))

        // If call's reponse is ok, just leave
        if (type === DeviceAuthTypes.DEVICE_BYPASS_AUTH_SUCCESS) {
            return
        }

        // If call failed, display the button
        setDisplay(true)
    }

    return (
        <Button theme="light" onClick={onClickBypass}>
            <FontAwesomeIcon icon="lock-open" title={t('device-auth-bypass')} />
        </Button>
    )
}

export default DeviceBypassAuth
